import { h } from 'vue'

const iconNames = [
  'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'bank-card', 'check',
  'circle-check', 'circle-close', 'circle-plus-outline', 'close', 'coin', 'delete',
  'document', 'document-copy', 'download', 'edit', 'edit-outline', 'files', 'goods',
  'info', 'lightning', 'loading', 'lock', 'medal', 'menu', 'money', 'office-building',
  'plus', 'postcard', 'question', 'rank', 'refresh', 'refresh-left', 'right',
  's-custom', 's-shop', 'search', 'service', 'setting', 'shopping-bag-2', 'sort',
  'success', 'switch-button', 'time', 'truck', 'upload', 'upload2', 'user',
  'user-solid', 'wallet', 'warning', 'warning-outline'
]

export function registerLegacyIcons(app) {
  iconNames.forEach(name => {
    const className = `el-icon-${name}`
    app.component(className, {
      name: `LegacyIcon${name.replace(/(^|-)(\w)/g, (_, separator, letter) => letter.toUpperCase())}`,
      render() { return h('i', { class: className, 'aria-hidden': 'true' }) }
    })
  })
}
